import CreatorMessagePage from "./CreatorMessagePage";

export default CreatorMessagePage;
